import React from "react"
import { BaseService } from "../services/base-service";

export class TiggbeeCanvaSchoolLearnMoreSection extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            scale: 1
        }
    }

    canvaContainerRef = React.createRef();
    canvaSectionWidth = 1366;
    canvaSectionHeight = 3864;

    componentDidMount = () => {
        this.setCanvaIframeSize();

        this.resizeObserver = new ResizeObserver(() => {
            this.setCanvaIframeSize();
        });

        if (this?.canvaContainerRef?.current) {
            this.resizeObserver.observe(this.canvaContainerRef.current);
        }
    }

    componentWillUnmount = () => {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    setCanvaIframeSize = () => {
        if (!this.canvaContainerRef || !this.canvaContainerRef.current) return;

        const containerWidth = this.canvaContainerRef.current.clientWidth;
        const newScale = containerWidth / this.canvaSectionWidth;

        this.setState({ scale: newScale });
    }

    render() {
        const { scale } = this.state;

        const originHTML = `<div style="position: relative; width: 100%; height: 0; padding-top: 251.0981%;
 padding-bottom: 0; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden;
 border-radius: 8px; will-change: transform;">
  <iframe loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;"
    src="https://www.canva.com/design/DAGvJJbeS88/YTy0nkKRRGQ1WIGeafz_fw/view?embed" allowfullscreen="allowfullscreen" allow="fullscreen">
  </iframe>
</div>
<a href="https://www.canva.com/design/DAGvJJbeS88/YTy0nkKRRGQ1WIGeafz_fw/view?utm_content=DAGvJJbeS88&utm_campaign=designshare&utm_medium=embeds&utm_source=link%22" target="_blank" rel="noopener">Tiggbee - Learn More Schools</a>`;

        const link = BaseService.getEmbedLinkFromCanvaShareHTML(originHTML);
        const containderHeight = (this?.canvaContainerRef?.current?.clientWidth ?? 1366) * 3864 / 1366;

        const html = (
            <>
                <div ref={this.canvaContainerRef} style={{ backgroundColor: 'red', width: '100%', height: '0px' }} />
                <div
                    style={{
                        width: '100%',
                        height: `${containderHeight}px`,
                        overflow: 'hidden',
                        position: 'relative',
                        padding: 0,
                    }}
                >
                    <div
                        style={{
                            width: `${this.canvaSectionWidth}px`,
                            height: `${this.canvaSectionHeight}px`,
                            transform: `scale(${scale})`,
                            transformOrigin: 'top left',
                            position: 'relative',
                        }}
                    >
                        <iframe
                            src={link}
                            style={{
                                width: `${this.canvaSectionWidth}px`,
                                height: `${this.canvaSectionHeight}px`,
                                border: 'none',
                                padding: 0,
                                margin: 0,
                            }}
                        />
                    </div>
                </div>
            </>
        )
        return html
    }
}